/*
 * pdp-qty-bubble.js
 * Decorative "pop" flourish for the PDP quantity pickers that opt into it:
 *   · Bubble Pop (default PDPs) — .pdp-product__qty--bubble
 *   · Neon Pods  (Robotryx)     — .pdp-product__qty--pods
 *
 * Progressive enhancement only — the picker is fully functional without this file:
 * Dawn's <quantity-input> (assets/global.js) still drives the value and dispatches a
 * native bubbling `change` event on the input when it changes. We listen for that and
 * re-trigger the `.is-popping` scale animation. The animation itself is defined per
 * variant (Bubble Pop's keyframe in section-main-product-pdp.css, Neon Pods' in
 * component-robotryx-pdp.css). Reduced-motion is honored in CSS (both keyframes are
 * disabled under prefers-reduced-motion), so no JS gating is needed here.
 */
(function () {
  document
    .querySelectorAll(
      '.pdp-product__qty--bubble .pdp-product__qty-input, .pdp-product__qty--pods .pdp-product__qty-input'
    )
    .forEach(function (input) {
      input.addEventListener('change', function () {
        input.classList.remove('is-popping');
        void input.offsetWidth; // reflow so the animation restarts on every change
        input.classList.add('is-popping');
      });
    });
})();
